export default __webpack_public_path__ + "static/media/logo-text.21760e92.svg";